import { InformationPill } from "../atoms/informationPill"
import { EditContactForm } from "../molecule/editContactForm"
import { IconButton } from "../atoms/buttons"
import { Modal } from "../components/modal"
import { useContext, useState } from "react";
import { postAPI } from "../api/api";
import { SkeletonCircle, SkeletonDiv } from "../atoms/skeletonloaders";
import { UserContext } from "../App";

export const UserContact = ({ user, isLoading, updateUser, allowEditing = true}) => {
    const [modalVisibility, setModalVisibility] = useState(false);
    var avatarSrc = user.avatar_url ? user.avatar_url : "https://ui-avatars.com/api/?name=" + user.full_name + "&background=random&color=fff&format=svg";
    const userInformation = useContext(UserContext)
    const isPublic = userInformation.account_type === 1
    function formatDepartments(items) {
        const names = items.map(item => item.department_name);
      
        switch (names.length) {
          case 0:
            return "";
          case 1:
            return names[0];
          case 2:
            return `${names[0]} en ${names[1]}`;
          default:
            return `${names.slice(0, -1).join(", ")} en ${names[names.length - 1]}`;
        }
      }

    async function saveContactInfo(newContactInfo) {
        var update_user_api = await postAPI("api/users/update", newContactInfo)
        if (update_user_api.status === "error" && update_user_api.message === "Invalid parameters") {
            return {"updated": false, "reason": "U heeft een ongeldig e-mailadres en/of telefoonnummer opgegeven."}
        } else if (update_user_api.status === "error") {
            return {"updated": false, "reason": "Er heeft zich een onbekende fout opgetreden. Probeer het later nogmaals."}
        } else if (update_user_api.status === "ok") {
            updateUser({...user, "email": newContactInfo.email, "phone_number": newContactInfo.phone_number})
            setModalVisibility(!modalVisibility)
            return {"updated": true, "reason": "ok"}
        }
    }

    if (isLoading) {
        return (
            <div className={`horizontal standard-padding`}>
                <SkeletonCircle style={{ "width": "7rem", "height": "7rem" }} />
                <div className={"standard-margin-left"} style={{ "flexGrow": 1 }}>
                    <SkeletonDiv style={{"width": "24rem", "height": "30px", "marginBottom": "0.75rem", "borderRadius": "100vh"}}/>
                    <SkeletonDiv style={{"width": "16rem", "height": "20px", "marginBottom": "0.75rem", "borderRadius": "100vh"}}/>
                    <div className={`horizontal`} style={{ "gap": "16px" }}>
                        {/* <InformationPill icon2={"mail"} content={<SkeletonDiv style={{"height": "1rem", "width": "10rem", "borderRadius": "100vh"}}/>} title={"E-mail"} /> */}
                        <InformationPill icon2={"briefcase"} content={<SkeletonDiv style={{"height": "1rem", "width": "6rem", "borderRadius": "100vh"}}/>} title={isPublic ? "Doelgroep" : "Afdeling"} />
                        <InformationPill icon2={"phone"} content={<SkeletonDiv style={{"height": "1rem", "width": "6rem", "borderRadius": "100vh"}}/>} title={"Telefoonnummer"} />
                    </div>
                </div>
                { allowEditing && 
                    <div>
                        <IconButton size={"1.7rem"} onClick={() => setModalVisibility(true)} color={"grey-700"} icon2={"edit"} />
                    </div>
                }
            </div>
        )
    }

    return (
        <div className={`horizontal standard-padding profile-content`}>
            <Modal
                size={"medium"}
                content={
                    <EditContactForm saveContactInfo={(newContactInfo) => saveContactInfo(newContactInfo)} contactDetails={user}/>
                }
                visible={modalVisibility}
                dismissable={() => setModalVisibility(false)} />
            <img className={"avatar avatar-small"} src={avatarSrc} alt="avatar" />
            <div className={"standard-margin-left"} style={{ "flexGrow": 1 }}>
                <h3 className="profile-name">{user.full_name}</h3>
                <h5 className="profile-email standard-margin-bottom">{user.email}</h5>
                <div className={`horizontal phone-information-pill`} style={{ "gap": "16px" }}>
                    {/* <InformationPill icon2={"mail"} content={user.email} title={"E-mail"} /> */}
                    {!isPublic && <InformationPill icon2={"briefcase"} content={user.roles.length > 0 ? formatDepartments(user.roles) : <span style={{fontStyle: "italic"}}>Geen afdelingen</span>} title={isPublic ? "Doelgroep(en)" : "Afdeling(en)"} />}
                    <InformationPill icon2={"phone"} content={user.phone_number ? user.phone_number : <span style={{ fontStyle: "italic"}}>Geen opgegeven</span>} title={"Telefoonnummer"} />
                    <InformationPill icon2={user.account_type === 1 ? "extern" : "intern"} content={user.account_type === 1 ? "Extern" : "Intern"} title={"Account type"} />
                </div>
            </div>
            { allowEditing && 
                <div className="edit-btn">
                    <IconButton size={"1.7rem"} onClick={() => setModalVisibility(true)} color={"grey-700"} icon2={"edit"} />
                </div>
            }
        </div>
    )
}